import React from 'react';
import {useTranslation} from "react-i18next";

import css from './ButtonCreate.module.css';


const ButtonCreate = (props) => {
    const {onClick} = props;
    const {t} = useTranslation();


    return (
        <button className={css.wrap} onClick={onClick}>
            <span>{t('button-create-text')}</span>
            <span className={css.icon}>+</span>
        </button>
    );
};

export {ButtonCreate};